import {Col, ColType, Crud} from "../../comp/crud";
import {ApiClient} from "../../api/ApiClient";
import '../clientConfig/index.scss'
import {TextCell, ClientLogStatus} from "../../comp/cell";

let cols: Col[] = [
    {
        name: "客户端",
        key: "code",
        hideInEdit: true,
        type: ColType.STRING
    },
    
    {
        name: "URL",
        key: "url",
        type: ColType.STRING,
        render: a => <TextCell width={300} text={a} />
    },
    {
        name: "请求",
        key: "req",
        type: ColType.STRING,
        render: a => <TextCell width={300} text={a} />
    },
    {
        name: "响应",
        key: "resp",
        type: ColType.STRING,
        render: a => <TextCell width={300} text={a} />
    },
    {
        name: "创建时间",
        key: "createdAt",
        type: ColType.STRING,
    },
    
]
export default function ClientLog(){
    return <Crud
        canUpdate={false}
        canCreate={false}
        name="客户端日志"
        entityKey="clientLogs"
        pageSize={50}
        cols={cols}
    />
}